//
/*
What does import React component from React mean?
With import React / React. Component you are 
guaranteeing all of React's source code will be bundled. 
With import { Component } , some tools will only bundle
the code needed to use the Component class, excluding the rest of React.


-------------

https://stackoverflow.com/questions/39361282/import-react-vs-react-component

import React, { Component } lets you do class Menu extends 
Component instead of class Menu extends React.Component. 
It's less typing and duplication of the React namespace, 
which is generally a desired modern coding convention.

Additionally, tools like Webpack 2 and Rollup do "tree shaking," 
meaning any unused exports are not bundled into your final code.
 With import React/React.Component you are guaranteeing all of 
 React's source code will be bundled. With import { Component }, 
 some tools will only bundle the code needed to use the Component 
 class, excluding the rest of React.
*/
// 1
import React, { Component } from "react";
//
//
import { bounce } from "react-animations";
import styled, { keyframes } from "styled-components";
import { ReactComponent as IconArrowDown } from "../icons/down-arrow-svgrepo-com_2.svg";

//

//
//        BOUNCING BUTTON
//

const BouncingButton = styled.div`
  width: 72px;
  height: 72px;

  display: flex;
  justify-content: center;
  align-items: center;
  /*  */
  animation: 4s ${keyframes`${bounce}`} infinite;
  cursor: pointer;
  border: 3px solid #fff;

  /* box-shadow: 0 0 20px rgb(248, 248, 248);
  background-color: rgb(248, 248, 248); */
  border-radius: 100%;
  //
  position: absolute;
  top: 80%;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
`;
//
const ArrowDown = styled.div`
  width: 50%;
  height: 50%;
  cursor: pointer;
  z-index: 1;
  pointer-events: stroke; /* SVG-only */
`;
// The Parent section
const ScrollToTopContainer = styled.div`
  /* width: 100vw;
  height: auto; */
  cursor: pointer;
  pointer-events: stroke; /* SVG-only */
  /* padding: 50px 0px 120px 0px;
  min-height: 1vh;
  display: flex; */
`;

//
//
//
// 2
const Scroll = () => {
  //3
  const handleClick = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  };
  //
  //
  //
  //

  return (
    //   4
    <BouncingButton onClick={handleClick}>
      <ArrowDown>
        <IconArrowDown src={IconArrowDown} />
      </ArrowDown>
    </BouncingButton>
  );
};

//
//
//6 here we pass the functional component to the class component
// It's not necessary but it makes me refresh my knowledge.
class ScrollToTop extends Component {
  //
  //
  render() {
    //
    //
    return (
      <>
        <ScrollToTopContainer>
          {/* 7 */}
          <Scroll />
        </ScrollToTopContainer>
      </>
    );
  }
}
// 8 export it to the component you want!
export default ScrollToTop;
